import { getVariant } from "@api/completion";
import fetchCourseProfileAttributes from "@api/operations/fetch-course-profile-attributes";
import fetchProfileAsAttributes from "@api/operations/fetch-profile-as-attributes";
import getToken from "@api/operations/get-token";
import Attribute from "@api/types/attribute";
import CourseCompletion from "@api/types/course-completion";
import { CFC } from "@api/types/cypress";
import ProfileAttribute from "@api/types/profile-attribute";
import InternalForm from "components/EnrolledCourseRegistrationForm/InternalForm";
import cookie from "js-cookie";
import { useEffect, useState } from "react";

const AdditionalInformationForm: CFC<{ completion: CourseCompletion }> = ({ completion }) => {
  const variant = getVariant(completion);
  const [token, setToken] = useState<string>(null);
  const [courseProfileAttributes, setCourseProfileAttributes] = useState<ProfileAttribute[]>([]);
  const [profileAttributes, setProfileAttributes] = useState<Attribute[]>([]);

  useEffect(() => {
    const cookieToken = cookie.get("token");

    if (cookieToken) {
      setToken(cookieToken);
    } else {
      getToken().then((serverToken) => {
        cookie.set("token", serverToken);
        setToken(serverToken);
      });
    }
  }, []);

  useEffect(() => {
    if (token) {
      fetchCourseProfileAttributes(token, completion.course, variant).then((p) => {
        setCourseProfileAttributes(p);
      });

      fetchProfileAsAttributes(token).then((a) => {
        setProfileAttributes(a);
      });
    }
  }, [token]);

  if (!token || courseProfileAttributes.length === 0 || profileAttributes.length === 0) {
    return null;
  }

  return (
    <InternalForm
      token={token}
      registrationFormData={courseProfileAttributes}
      profile={profileAttributes}
      email={completion.email}
      productCode={completion.course}
      completionId={completion.id}
    />
  );
};

export default AdditionalInformationForm;
